import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react'

import { type PaginationState, SortingState } from '@tanstack/react-table'

interface PaginationContextType {
  pagination: PaginationState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  searchQuery: string
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>
  sorting: SortingState
  setSorting: React.Dispatch<React.SetStateAction<SortingState>>
}

const PaginationContext = createContext<PaginationContextType | undefined>(
  undefined,
)

export const PaginationProvider = ({ children }: PropsWithChildren) => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [searchQuery, setSearchQuery] = useState('')
  const [sorting, setSorting] = useState<SortingState>([])

  const value = {
    pagination,
    setPagination,
    searchQuery,
    setSearchQuery,
    sorting,
    setSorting,
  }

  return (
    <PaginationContext.Provider value={value}>
      {children}
    </PaginationContext.Provider>
  )
}

export function usePagination() {
  const context = useContext(PaginationContext)

  if (context === undefined) {
    throw new Error('usePagination must be used within a PaginationProvider')
  }

  return context
}
